import { createReducer, on } from '@ngrx/store';

import { IProfile } from '../../shared/models/Profile';
import {
    clearUpdateProfile,
    clearValidCurrentPass,
    clearValidNewPhone,
    errorGetProfile,
    errorUpdateProfile,
    errorValidCurrentPass,
    errorValidNewPhone,
    getProfile,
    successGetProfile,
    successUpdateProfile,
    successValidCurrentPass,
    successValidNewPhone,
    updateProfile,
    validCurrentPass,
    validNewPhone,
} from '../actions';

/*
 * Consulta los datos de perfil y configuracion para el modulo
 */

export interface ProfileState {
    error: Error | null;
    failed: boolean;
    success: boolean;
    loading: boolean;
    data: IProfile;
}

export const ProfileInitState: ProfileState = {
    error: null,
    failed: false,
    success: false,
    loading: false,
    data: {} as IProfile
}

const _profileReducer = createReducer(
    ProfileInitState,
    on(getProfile, (state) => (
        {
            ...state,
            loading: true,
            success: false,
            failed: false,
        }
    )),
    on(successGetProfile, (state, { data }) => (
        {
            ...state,
            loading: false,
            success: true,
            data: data.perfil
        }
    )),
    on(errorGetProfile, (state, { payload }) => (
        {
            ...state,
            loading: false,
            failed: true,
            error: { ...payload }
        }
    )),
);

export function ProfileReducer(state: any, action: any) {
    return _profileReducer(state, action);
}

/*
 * Actualiza datos del perfil
 */

export interface UpdateProfileState {
    error: Error | null;
    failed: boolean;
    success: boolean;
    loading: boolean;
    data: IProfile;
}

export const UpdateProfileInit: UpdateProfileState = {
    error: null,
    failed: false,
    success: false,
    loading: false,
    data: null,
}

const _updateProfileReducer = createReducer(
    UpdateProfileInit,
    on(updateProfile, state => (
        {
            ...state,
            loading: true,
            success: false,
            failed: false,
        }
    )),
    on(successUpdateProfile, (state, { data }) => (
        {
            ...state,
            loading: false,
            success: true,
            data: data[0]
        }
    )),
    on(errorUpdateProfile, (state, { payload }) => (
        {
            ...state,
            loading: false,
            failed: true,
            error: { ...payload }
        }
    )),
    on(clearUpdateProfile, state => ({ ...state, ...UpdateProfileInit }))
);

export function UpdateProfileReducer(state: any, action: any) {
    return _updateProfileReducer(state, action);
}

/*
 * Valida la contraseña actual
 */

export interface CurrentPassState {
    error: Error | null;
    failed: boolean;
    success: boolean;
    loading: boolean;
    data: any;
}

export const CurrentPassInit: CurrentPassState = {
    error: null,
    failed: false,
    success: false,
    loading: false,
    data: null,
}

const _currentPassReducer = createReducer(
    CurrentPassInit,
    on(validCurrentPass, state => (
        {
            ...state,
            loading: true,
            success: false,
            failed: false,
        }
    )),
    on(successValidCurrentPass, (state, { data }) => (
        {
            ...state,
            loading: false,
            success: true,
            data
        }
    )),
    on(errorValidCurrentPass, (state, { payload }) => (
        {
            ...state,
            loading: false,
            failed: true,
            error: { ...payload }
        }
    )),
    on(clearValidCurrentPass, state => ({ ...state, ...CurrentPassInit }))
);

export function CurrentPassReducer(state: any, action: any) {
    return _currentPassReducer(state, action);
}

/*
 * Valida nuevo teléfono
 */

export interface NewPhoneState {
    error: Error | null;
    failed: boolean;
    success: boolean;
    loading: boolean;
    code: number;
}

export const NewPhoneInit: NewPhoneState = {
    error: null,
    failed: false,
    success: false,
    loading: false,
    code: null,
}

const _newPhoneReducer = createReducer(
    NewPhoneInit,
    on(validNewPhone, state => (
        {
            ...state,
            loading: true,
            success: false,
            failed: false,
        }
    )),
    on(successValidNewPhone, (state, { code }) => (
        {
            ...state,
            loading: false,
            success: true,
            code
        }
    )),
    on(errorValidNewPhone, (state, { payload }) => (
        {
            ...state,
            loading: false,
            failed: true,
            error: { ...payload }
        }
    )),
    on(clearValidNewPhone, state => ({ ...state, ...NewPhoneInit }))
);

export function NewPhoneReducer(state: any, action: any) {
    return _newPhoneReducer(state, action);
}
